"use client";

import { useEffect, useState } from "react";
import Script from "next/script";

const ClientGTM = () => {
  const [gtmId, setGtmId] = useState<string>("");

  useEffect(() => {
    const newGtmId = window.location.href.includes("trainmobile")
      ? "GTM-KWRR8RT"
      : "GTM-WBH8JLPZ";
    setGtmId(newGtmId);
  }, []);

  if (!gtmId) {
    return null;
  }

  return (
    <Script id="google-tag-manager" strategy="afterInteractive">
      {`
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),
              dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `}
    </Script>
  );
};

export default ClientGTM;
